import { useApi } from "#hooks/useApi"
import { courseGet } from "#training/services/Api"
import { TextField } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete"
import CircularProgress from "@mui/material/CircularProgress"
import { Fragment, useEffect, useMemo, useState } from "react"

/**
 *
 * @param {object} props
 * @property {} props.data
 * @property {} props.value
 * @returns
 */
const SelectCourse = (props) => {
	const params = useMemo(() => ({ list: true }), [])
	const { data, loading } = useApi(courseGet, { autoFetch: !props.data, params })
	const { cursos } = data || { cursos: [] }
	const useData = useMemo(() => props.data ?? cursos, [cursos, props.data])
	const [selectedDepartamento, setSelectedDepartamento] = useState(null)
	useEffect(() => {
		if (!props?.value) setSelectedDepartamento(null)
		else
			useData.forEach((element) => {
				if (props.value === element.id) setSelectedDepartamento(element)
			})
	}, [props.value, useData])

	return (
		<Autocomplete
			fullWidth={props.fullWidth}
			style={{ minWidth: props.minWidth }}
			disabled={props.disabled || (loading && !props.data)}
			value={selectedDepartamento} // El valor seleccionado
			onChange={(event, newValue) => {
				if (props.setValue) props.setValue(newValue?.id)
				setSelectedDepartamento(newValue)
			}}
			options={useData}
			loading={true}
			getOptionLabel={(option) => option?.nombre}
			renderOption={(props, option) => (
				<li {...props} key={"curso-" + option.id}>
					{option.nombre}
				</li>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					label="Cursos"
					slotProps={{
						input: {
							...params.InputProps,
							endAdornment: (
								<Fragment>
									{loading ? (
										<CircularProgress color="inherit" size={20} />
									) : null}
									{params.InputProps.endAdornment}
								</Fragment>
							),
						},
					}}
				/>
			)}
		/>
	)
}
export default SelectCourse
